import React, { FC, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { Box, Typography, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

const DropzoneContainer = styled(Paper)(({ theme }) => ({
  border: `2px dashed ${theme.palette.divider}`,
  padding: theme.spacing(4),
  textAlign: 'center',
  cursor: 'pointer',
  transition: 'border-color 0.3s',
  '&:hover': {
    borderColor: theme.palette.primary.main,
  },
}));

interface MediaUploaderProps {
  onFilesAccepted: (files: File[]) => void;
}

const MediaUploader: FC<MediaUploaderProps> = ({ onFilesAccepted }) => {
  const onDrop = useCallback((acceptedFiles: File[]) => {
    onFilesAccepted(acceptedFiles);
  }, [onFilesAccepted]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'image/*': ['.jpeg', '.png', '.gif', '.webp'],
      'video/*': ['.mp4', '.webm', '.ogg'],
      'audio/*': ['.mp3', '.wav', '.aac'],
    }
  });

  return (
    <DropzoneContainer {...getRootProps()}>
      <input {...getInputProps()} />
      <Box>
        {
          isDragActive ?
            <Typography>Drop the files here ...</Typography> :
            <Typography>Drag 'n' drop some files here, or click to select files</Typography>
        }
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          Images, videos, and audio files are accepted.
        </Typography>
      </Box>
    </DropzoneContainer>
  );
};

export default MediaUploader;
